import { render, staticRenderFns } from "./transGood.vue?vue&type=template&id=350b4db2&scoped=true&"
import script from "./transGood.vue?vue&type=script&lang=js&"
export * from "./transGood.vue?vue&type=script&lang=js&"
import style0 from "./transGood.vue?vue&type=style&index=0&id=350b4db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b4db2",
  null
  
)

component.options.__file = "transGood.vue"
export default component.exports